import React from 'react';
import { Drawer, Typography } from 'antd';
import { ClockCircleOutlined } from '@ant-design/icons';
import { WeeklyScheduleList } from './WeeklyScheduleList';
import { useHomeStrings } from '../../hooks/useHomeStrings';
import type { HomeWeeklyScheduleItem } from '../../model/types';

interface Props {
  open: boolean;
  onClose: () => void;
  schedule: HomeWeeklyScheduleItem[];
}

export const WeeklySchedulePanel: React.FC<Props> = ({ open, onClose, schedule }) => {
  const STRINGS = useHomeStrings();
  return (
  <Drawer
    placement="bottom"
    height="auto"
    open={open}
    onClose={onClose}
    destroyOnClose={false}
    title={
      <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
        <ClockCircleOutlined style={{ color: 'var(--bl-accent, #3390ec)', fontSize: 16 }} />
        <Typography.Text style={{ fontWeight: 600, fontSize: 15 }}>
          {STRINGS.WEEKLY_SCHEDULE_TITLE}
        </Typography.Text>
      </div>
    }
    styles={{
      body: {
        padding: '8px 4px',
        paddingBottom: 'calc(12px + env(safe-area-inset-bottom, 0px))',
      },
      header: {
        borderBottom: '1px solid var(--bl-divider, #f0f0f0)',
        paddingBottom: 12,
      },
    }}
  >
    <WeeklyScheduleList schedule={schedule} />
  </Drawer>
  );
};
